export const getColorForModule = (module = "") => {
  switch (module) {
    case "DESADUANAMIENTO LIBRE":
      return "green";
    case "ERROR":
      return "green";
    case "user":
      return "yellow";
    case "ADUANERO CONCLUIDO":
      return "orange";
    case "SIN MÓDULO":
      return "red";
    case "ERROR EN NUMERO DE INTERGRACIÓN":
      return "purple";
    default:
      return "gray";
  }
};
